import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import FormTitle from '../../../../library/form/components/FormTitle'
import FormLabel from '../../../../library/form/components/FormLabel'
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormPaging from '../../../../library/form/components/FormPaging'
import ItemPriceRow from './ItemPriceRow'
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../../../library/layout/Index";

const ItemPrice = (props) => {
    const { formObject, viewData } = props;

    const itemPriceRowData = () => {
        if(Object.keys(viewData).length>0){
            return(
                Object.values(viewData).map((row, index)=>(
                    <ItemPriceRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />
                ))
            )
        }
    }
    if(!viewData)
        return(null)

    return (
        <div>
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <FormTitle formObject={formObject} value='Price Chart' />
                    </UiTitle>
                    <UiAction>
                        <FormButton formObject={formObject} ksc="n" rowKey="" className="uiActionIconButton" starIcon={"adds"}
                            action={{ actionId: "new",  actionParam: {}, containerKey: "popup" }}
                            text={<SarasTrans value="Add Price" />}
                        />
                        <FormPaging formObject={formObject} />

                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <div className="uiSecContents">
                        <ul className="uiListTable">
                            <li className="uiSearchHeading">
                                <span className="uiColumnCenter uiColumn150"><SarasTrans value="Price Date" /></span>
                                <span className="uiColumnCenter uiColumn100"><SarasTrans value="Price Type" /></span>
                                <FormLabel customWrapper="span" wrapperClass="uiColumnCenter uiColumn70" formObject={formObject} rowKey="" headerKey="headerRows" action={{ paramName: "priceValueConfig" }} value="Value" />
                                <FormLabel customWrapper="span" wrapperClass="uiColumnCenter uiColumn70" formObject={formObject} rowKey="" headerKey="headerRows" action={{ paramName: "priceValue2Config" }} value="Value" />
                                <span className="uiColumnCenter uiColumn50"><SarasTrans value="Unit" /></span>
                                <span className="uiColumnCenter uiColumn50"><SarasTrans value="Currency" /></span>
                                <span className="uiColumnCenter uiColumn100"><SarasTrans value="For" /></span>
                                <span className="uiColumnCenter uiColumn100"><SarasTrans value="Comments" /></span>
                                <span className="uiColumnCenter uiColumn100"><SarasTrans value="Additional Info" /></span>
                                <span className="uiColumnCenter uiColumn70"><SarasTrans value="Action" /></span>
                            </li>
                            {
                                itemPriceRowData()
                            }
                            
                        </ul>
                    </div>
                </UiViewContent>
            </UiView>
        </div>
    )
}

export default withView(ItemPrice, "itemPrice", "")